import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIChatService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import fileIcon from "../../../../assets/icon/files.png";
import { isPC, isUniFrameWork } from "../../../../utils/env";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["close"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var inputRef = ref();
    var _currentConversation = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var onIconClick = function onIconClick() {
      if (isUniFrameWork) {
        // uniapp app 不支持选择文件发送
        return;
      } else {
        var _inputRef$value, _inputRef$value2;
        (inputRef === null || inputRef === void 0 || (_inputRef$value = inputRef.value) === null || _inputRef$value === void 0 ? void 0 : _inputRef$value.click) && (inputRef === null || inputRef === void 0 || (_inputRef$value2 = inputRef.value) === null || _inputRef$value2 === void 0 ? void 0 : _inputRef$value2.click());
      }
    };
    var sendFileMessage = function sendFileMessage(e) {
      var _e$target, _currentConversation$, _currentConversation$2, _currentConversation$3;
      if ((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.files) === null || _e$target === void 0 ? void 0 : _e$target.length) <= 0) {
        return;
      }
      var options = {
        to: (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 || (_currentConversation$ = _currentConversation$.groupProfile) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.groupID) || (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.userProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.userID),
        conversationType: _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type,
        payload: {
          file: e === null || e === void 0 ? void 0 : e.target
        },
        needReadReceipt: isEnabledMessageReadReceiptGlobal()
      };
      TUIChatService.sendFileMessage(options);
      e.target.value = "";
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(ToolbarItemContainer, {
        iconFile: _unref(fileIcon),
        title: "文件",
        iconWidth: _unref(isUniFrameWork) ? '32px' : '21px',
        iconHeight: _unref(isUniFrameWork) ? '25px' : '18px',
        needDialog: false,
        onOnIconClick: onIconClick
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass(['file-upload', !_unref(isPC) && 'file-upload-h5'])
          }, [_createElementVNode("input", {
            title: "文件",
            type: "file",
            "data-type": "file",
            accept: "*",
            onChange: sendFileMessage,
            ref_key: "inputRef",
            ref: inputRef
          }, null, 544)], 2)];
        }),
        _: 1
      }, 8, ["iconFile", "iconWidth", "iconHeight"]);
    };
  }
});